export default "__VITE_ASSET__Jb8ycf34__"